module.exports = __webpack_public_path__ + "static/media/eap3.7e43736d.md";